import { scale } from '@components/frame';
import { getOEEEffectivenessLabel } from '@components/machines/components/Utilization/components/chart/components/helpers';
import { UseManageUtilizationPopupParams, UseManageUtilizationPopupReturn } from '@components/machines/components/Utilization/components/chart/types';

export const useManageUtilizationPopup = ({
  selectedItem,
  selectedIndex,
  toGo,
  barBlockWidth,
}: UseManageUtilizationPopupParams): UseManageUtilizationPopupReturn => {
  const chartHeight = scale(119, false);
  const lineLeft = scale(15) + selectedIndex * barBlockWidth + barBlockWidth / 2;

  const teepPercent = selectedItem.teep != null ? (selectedItem.teep * 100).toFixed(1) : '0.0';
  const oeePercent = selectedItem.oee != null ? (selectedItem.oee * 100).toFixed(1) : '0.0';

  const [teepInt, teepDec] = String(teepPercent).split('.');
  const [oeeInt, oeeDec] = String(oeePercent).split('.');
  const effectiveness = getOEEEffectivenessLabel(selectedItem.oee);

  const linkConfig = toGo(selectedItem, true);

  return {
    chartHeight,
    lineLeft,
    teepInt,
    teepDec,
    oeeInt,
    oeeDec,
    effectiveness,
    linkConfig,
  };
};
